import { Config } from "./configTypes";
import malaysiaConfig from "./malaysiaConfig";
import triveInternationalConfig from "./triveInternationalConfig";
import triveInvestConfig from "./triveInvestConfig";

const configMap: { [key: string]: Config } = {
  malaysia: malaysiaConfig,
  international: triveInternationalConfig,
  triveinvest: triveInvestConfig,
};

const getConfig = (): Config => {
  const url = window.location.href.toLowerCase();

  for (const key in configMap) {
    if (url.includes(key)) {
      return configMap[key];
    }
  }

  return triveInternationalConfig;
};

export default getConfig;
